module.exports = __webpack_public_path__ + "static/media/27OCHA20.f8935363.jpg";